import { WorkerRequirementStatus } from "@clipboard-health/contract-worker-app-bff";
import { DeprecatedGlobalAppV1Paths } from "@src/appV2/App/paths";
import { useRef } from "react";
import { Redirect } from "react-router-dom";

import { PageWrapper } from "../../../components/PageWrapper";
import { StickyScrollPageHeader } from "../../../components/StickyScrollPageHeader";
import { DocumentDetailsMetadata } from "../Metadata";
import { DocumentDetailsRequiredBySection } from "../RequiredBySection/Section";
import { DocumentPageScrollWrapper } from "../ScrollWrapper";
import { DocumentDetailsStatusCard } from "../StatusCard";
import { useRequirementDetailsContext } from "../useRequirementDetailsContext";

/*
  This page currently only shows the approved status for professional references.
  All other statuses are still redirected to the normal professional references page.
*/
export function DocumentDetailsProfessionalReferencesPage() {
  const { requirement: workerRequirement } = useRequirementDetailsContext();
  const scrollRef = useRef<HTMLDivElement>(null);
  const { requirement, status } = workerRequirement;
  const { name } = requirement?.attributes ?? {};

  if (status !== WorkerRequirementStatus.APPROVED) {
    return <Redirect to={DeprecatedGlobalAppV1Paths.PROFESSIONAL_REFERENCE} />;
  }

  return (
    <PageWrapper variant="tertiary">
      <StickyScrollPageHeader
        shouldWrapTitle
        title={name ?? ""}
        headerVariant="tertiary"
        scrollContainerRef={scrollRef}
      />

      <DocumentPageScrollWrapper ref={scrollRef}>
        <DocumentDetailsMetadata />
        <DocumentDetailsStatusCard hideViewDocument />
        <DocumentDetailsRequiredBySection />
      </DocumentPageScrollWrapper>
    </PageWrapper>
  );
}
